import Closeout from './Closeout';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from './Closeout.state';

export default connect(mapStateToProps, mapDispatchToProps)(Closeout);
